// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Themes */\n.theme--light.v-sheet {\n  background-color: #fff;\n  border-color: #fff;\n  color: rgba(0,0,0,0.87);\n}\n.theme--dark.v-sheet {\n  background-color: #424242;\n  border-color: #424242;\n  color: #fff;\n}\n.v-sheet {\n  display: block;\n  border-radius: 2px;\n  position: relative;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.v-sheet--tile {\n  border-radius: 0;\n}\n", ""]);
// Exports
module.exports = exports;
